import { Box } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { ModBox } from '../../../../comps/ModifiedBox/ModifiedBox'
import { useStores } from '../../../../data/store'
import { AddNewUserForm } from './AddNewUserForm'
import { AddNewUserInterface } from './AddNewUserInterface'
import { Header } from './Header'
import { styles } from './styles'

const AddNewUser = ({ hide }: AddNewUserInterface) => {
  const navigation = useNavigation()
  const { getAcessRightData, getJfsUserId, mid, hasSupersetPermission } = useStores((store) => ({
    getAcessRightData: store.userManagement.getAcessRightData,
    getJfsUserId: store.user.session.getJfsUserId(),
    mid: store.user.selectedMid,
    hasSupersetPermission: store?.userManagement?.hasSupersetPermission(),
  }))
  const accessRightsData = getAcessRightData(undefined)

  if (hide) {
    return null
  }
  return (
    <Box {...styles.superParent}>
      <ModBox {...styles.maincontainer}>
        <Box {...styles.container}>
          <Header navigation={navigation} hide={false} isEditing={false} />
          <AddNewUserForm editData={{ accessRightsData, getJfsUserId, mid, hasSupersetPermission }} />
        </Box>
      </ModBox>
    </Box>
  )
}

export default AddNewUser
